import api from '~config/api';

export const triggerCheckout = ({ quickCode, incumbent, value, field }) =>
  api.get(
    `/verifications/send_kayak_checkout_code?quick_code=${quickCode}&incumbent=${incumbent}&value=${value}&field=${field}`
  );
